import store from '@state/store'
import routes from './routes'
import Vue from 'vue'
import VueRouter from 'vue-router'
// https://github.com/declandewet/vue-meta
import VueMeta from 'vue-meta'
import {
  checkGenreValid,
  getPrefectureCodeFromAreaCode,
	getMunicipalityFromAreaCode,
  DISPLAYMODE,
} from '@state/modules/facility-search.js'
import VueQriously from 'vue-qriously'
Vue.use(VueQriously)
Vue.use(VueRouter)
Vue.use(VueMeta)

const router = new VueRouter({
  routes,
  base: process.env.NODE_ENV === 'production' ? '/' : '/',
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  // store.dispatch('layout/endLoading')
  // If this isn't an initial page load...

  var sPd = window.localStorage.getItem('post_data')
  if (sPd) {
    var oPd = JSON.parse(sPd)
    var SsnId = oPd.SsnId
    if (routeTo.query && routeTo.query.iframemode !== 'k5q87r2c' &&
      routeTo.params && routeTo.params.iframemode !== 'k5q87r2c' && SsnId  ) {
      window.localStorage.setItem('SsnId', SsnId)
      const pattern = new RegExp('(SsnId=([^&]*))(&)*', 'g')
      const url = location.href.replace(pattern, '')
      window.location.replace(url)
      return
    }
  }

  if (routeTo.query && routeTo.query.login_flg == 0) {
    const pattern = new RegExp('(login_flg=([^&]*))(&)*', 'g')
    const url = location.href.replace(pattern, '')
    store.dispatch('auth/logout')
    store.dispatch('facilitySearch/setDisplayMode', DISPLAYMODE.START)
    store.dispatch('facilitySearch/clearSearch')
    window.location.replace(url)
    return
  }

  if (routeTo.query && routeTo.query.SsnId) {
    window.localStorage.setItem('SsnId', routeTo.query.SsnId)
    const pattern = new RegExp('(SsnId=([^&]*))(&)*', 'g')
    const url = location.href.replace(pattern, '')
    window.location.replace(url)
    return
  } else {
    if (routeTo.query && routeTo.query.login_flg == 1) {
      const pattern = new RegExp('(login_flg=([^&]*))(&)*', 'g')
      const returnUrl = location.href.replace(pattern, '')
      store.dispatch('facilitySearch/setDisplayMode', DISPLAYMODE.START)
      store.dispatch('facilitySearch/clearSearch')
      const url = `${process.env.VUE_APP_SSO_URL}?qServiceId=${
        process.env.VUE_APP_SSO_ID
      }&qLoginStatusCheckFlg=1&qUrl=${encodeURIComponent(decodeURI(returnUrl))}`
      // const encodeUrl = encodeURI(url)
      window.location.href = url
      return
    }
  }

  if (routeTo.query && routeTo.query.iframemode === 'k5q87r2c') {
    window.sessionStorage.setItem('iframemode', '1')
  }


  if (routeFrom.name !== null) {
    routeFrom.meta.containerScrollTop = document.getElementById(
      'jaf_container'
    ).scrollTop
  }

  if (routeTo.name !== 'facility-detail' && routeTo.name !== 'coupon-detail') {
    store.dispatch('layout/disableCouponDetailAlive')
  }

  if (
    routeFrom.name == 'facility-search' &&
    routeTo.name == 'map' &&
    !routeFrom.meta.isBack
  ) {
    store.dispatch('layout/disableMapAlive')
  }

  if (routeTo.name == 'search-result' || routeTo.name == 'map') {
    if (routeTo.query) {
      if (routeTo.query.genre) {
        if (routeTo.query.genre == 'Z') {
          store.dispatch('facilitySearch/checkIsOnline')
          store.dispatch('facilitySearch/setTempIsOnline', true)
          store.dispatch('facilitySearch/setGenreCode', '')
          store.dispatch('facilitySearch/setTempGenre', '')
          sessionStorage.removeItem('SHOP')
        } else if (checkGenreValid(routeTo.query.genre)) {
          store.dispatch('facilitySearch/setGenreCode', routeTo.query.genre)
          store.dispatch('facilitySearch/setTempGenre', routeTo.query.genre)
        } else {
          router.replace({ name: 'facility-search' })
          return
        }
      } else {
        store.dispatch('facilitySearch/setGenreCode', '')
        store.dispatch('facilitySearch/setTempGenre', '')
      }

      if (routeTo.query.query) {
        store.dispatch('facilitySearch/setSearchWord', routeTo.query.query)
        store.dispatch('facilitySearch/setTempSearchWord', routeTo.query.query)
      } else {
        store.dispatch('facilitySearch/setSearchWord', '')
        store.dispatch('facilitySearch/setTempSearchWord', '')
      }

      if (routeTo.query.area) {
        store.dispatch('facilitySearch/setAreaCode', routeTo.query.area)
				store.dispatch(
          'facilitySearch/setTempPrefecture',
          getPrefectureCodeFromAreaCode(routeTo.query.area)
				)
				store.dispatch(
          'facilitySearch/setTempMunicipality',
          getMunicipalityFromAreaCode(routeTo.query.area)
        )
      } else {
        store.dispatch('facilitySearch/setAreaCode', '')
				store.dispatch('facilitySearch/setTempPrefecture', '')
				store.dispatch('facilitySearch/setTempMunicipality', '')
      }

      if (routeTo.query.online && routeTo.query.online == 1) {
        store.dispatch('facilitySearch/checkIsOnline')
        store.dispatch('facilitySearch/setTempIsOnline', true)
      } else if (routeTo.query.genre != 'Z') {
        store.dispatch('facilitySearch/uncheckIsOnline')
        store.dispatch('facilitySearch/setTempIsOnline', false)
      }

      if (routeTo.query.limited && routeTo.query.limited == 1) {
        store.dispatch('facilitySearch/checkIsLimited')
        store.dispatch('facilitySearch/setTempIsLimited', true)
      } else {
        store.dispatch('facilitySearch/uncheckIsLimited')
        store.dispatch('facilitySearch/setTempIsLimited', false)
      }

      if (routeTo.query.coupon && routeTo.query.coupon == 1) {
        store.dispatch('facilitySearch/checkCoupon')
        store.dispatch('facilitySearch/setTempExistCoupon', true)
      } else {
        store.dispatch('facilitySearch/uncheckCoupon')
        store.dispatch('facilitySearch/setTempExistCoupon', false)
      }

      if (routeTo.query.premium && routeTo.query.premium == 1) {
        store.dispatch('facilitySearch/checkIsPremiam')
        store.dispatch('facilitySearch/setTempIsPremiam', true)
      } else {
        store.dispatch('facilitySearch/uncheckIsPremiam')
        store.dispatch('facilitySearch/setTempIsPremiam', false)
      }

      if (routeTo.query.newshop && routeTo.query.newshop == 1) {
        store.dispatch('facilitySearch/checkIsNewShop')
        store.dispatch('facilitySearch/setTempIsNewShop', true)
      } else {
        store.dispatch('facilitySearch/uncheckIsNewShop')
        store.dispatch('facilitySearch/setTempIsNewShop', false)
      }

      if (routeTo.query.nowAround && routeTo.query.nowAround == 1) {
        store.dispatch('facilitySearch/setIsNowAround', true)
        store.dispatch('facilitySearch/setTempIsNowAround', true)
      } else {
        store.dispatch('facilitySearch/setIsNowAround', false)
        store.dispatch('facilitySearch/setTempIsNowAround', false)
      }

      if (
        routeTo.query.pointSearch &&
        routeTo.query.pointSearch == 1 &&
        routeTo.query.lon &&
        routeTo.query.lat
      ) {
        store.dispatch('facilitySearch/checkPointSearch')
        store.dispatch('facilitySearch/setTempIsPointSearch', true)
        let location = {
          lon: routeTo.query.lon,
          lat: routeTo.query.lat,
        }
        store.dispatch('facilitySearch/setLonLat', location)
      } else {
        store.dispatch('facilitySearch/uncheckPointSearch')
        store.dispatch('facilitySearch/setTempIsPointSearch', false)
      }
    } else {
      store.dispatch('facilitySearch/clearSearch')
      router.replace({ name: 'facility-search' })
      return
    }
  }

  return next()
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // TODO: セッションチェック
    await store.dispatch('auth/logIn')
/*
    if (
      !store.state.auth.loggedIn &&
      routeTo &&
      routeTo.name == 'facility-detail'
    ) {
      const url = `${process.env.VUE_APP_SSO_URL}?qServiceId=${
        process.env.VUE_APP_SSO_ID
      }&qUrl=${encodeURIComponent(decodeURI(location.href))}`
      location.href = url
      return
    }
*/
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              if (routeFrom.name === args[0].name) {
                // Complete the animation of the route progress bar.
                // NProgress.done()
              }
              // Complete the redirect.
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          // Otherwise, continue resolving the route.
          resolve()
        }
      })
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    // next({ path: '/system-error' })
    return next()
  }

  // If we reach this point, continue resolving the route.
  next()
})

// When each route is finished evaluating...
router.afterEach((routeTo, routeFrom) => {
  // Complete the animation of the route progress bar.
})

router.onError((e) => {
  window.location.reload()
})

export default router
